import moment from "moment"

export const getColumnData = (rowData: any, columnAccessor: any) => {
  if (rowData[columnAccessor] === undefined) {
    return ""
  }

  if (columnAccessor === "CreatedDate" || columnAccessor === "UpdatedDate") {
    let date = rowData[columnAccessor]
    date = moment(date).format("YYYY-MM-DD")
    return (date === "Invalid date") ? "N/A" : date
  }

  let response = rowData[columnAccessor]
  return response
}

export const setCheckBoxData = (value: any) => {
  if (value === true) {
    return true
  }

  if (typeof value === "string") {

    if (value?.toLowerCase() === "active") {
      return true;
    }
  }

  return false
}